import { v3Url } from '@/utils/fetcher';
import useListLoader from '../base/useListLoader';

function responseToItems(response) {
  const { companies = {}, teams = {} } = response.data.included;
  const usersList = response.data.people || [];

  /* eslint-disable no-param-reassign */
  usersList.forEach((user) => {
    if (user.company && companies[user.company.id]) {
      user.company = companies[user.company.id];
    }

    user.teams?.forEach((team, index) => {
      if (teams[team.id]) {
        user.teams[index] = teams[team.id];
      }
    });

    /* eslint-enable no-param-reassign */
  });
  return usersList;
}

/**
 * Loads a list of people from the Teamwork v3 API.
 */
export default function usePeopleLoader({ params, count, pageSize = 50 }) {
  const { state } = useListLoader({
    url: v3Url('people'),
    params,
    count,
    responseToItems,
    pageSize,
  });
  return state;
}
